module.exports = __webpack_public_path__ + "static/img/icon-total.9da696c6.svg";